exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".errorMessage{\r\n    bottom: -13px;\r\n    left: 0px;\r\n}\r\n.input-group-addon{\r\n    min-width: 41px;\r\n}\r\n.page-header{\r\n    padding-top: 9px;\r\n}\r\n.contact_sec{    padding-bottom: 18px;}\r\n.contact_sec a{    color: #f5821f;}\r\n.contact_sec a:hover{    color: #fff;}\r\n\r\n.signature_sec{\r\n    display: block;\r\n    height: 38px;\r\n}\r\n.inner-check-wrapper .UserSignatureDiv img {\r\n    width: 100%;\r\n    height: 100%;    -o-object-fit: contain;    object-fit: contain;\r\n}\r\n.signaturenotrec {\r\n    margin-top: 0px;\r\n}\r\n.inner-check-wrapper .UserSignatureDiv {\r\n    bottom: 53px;    top: unset;    height: 37px;\r\n}\r\n.bankName_sub{\r\n    top: 14.5em;\r\n    left: 2.1em;\r\n    width: 300px;\r\n}\r\n.bankName_sub span{\r\n    font-size: 10px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/sendcheck/sendcheck.component.css
// module id = ../../../../../src/app/sendcheck/sendcheck.component.css
// module chunks = main